module.exports = require("@embedpdf/plugin-zoom/react");